import { apiRequest } from '@/lib/api-client';
import {
  assertAnalyticsResponseScope,
  normalizeAnalyticsAddress
} from '@/lib/investor-analytics';
import {
  investorAttributionQuerySchema,
  investorAttributionResponseSchema,
  type InvestorAttributionQuery,
  type InvestorAttributionResponse
} from '../types/api';

export async function fetchInvestorAttribution(
  address: string,
  chainId: number,
  params: InvestorAttributionQuery = {},
  signal?: AbortSignal
): Promise<InvestorAttributionResponse> {
  const investor = normalizeAnalyticsAddress(address);
  const query = investorAttributionQuerySchema.parse(params);
  const response = await apiRequest(
    `/api/v1/investor/${encodeURIComponent(investor)}/attribution`,
    investorAttributionResponseSchema,
    {
      auth: 'required',
      chainId,
      query,
      signal
    }
  );

  assertAnalyticsResponseScope(investor, chainId, response);
  return response;
}
